<template>
  <div class="activity-detail full-page">
    <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
      <div
        class="cover"
        :style="{ backgroundImage: `url(${activityData.image})` }"
      ></div>
      <div class="info">
        <div class="title">{{ activityData.title }}</div>
        <div class="time">
          活动时间：{{ startTimeText }} ~ {{ endTimeText }}
        </div>
        <div class="address">活动地点：{{ activityData.address }}</div>
        <div class="status" v-if="activityData.finished"></div>
      </div>
      <div class="content reset-rich-text" v-html="activityData.details"></div>
      <div v-if="activityData.isSignUp" class="submit-box">
        <van-button
          v-if="assignStatus.status"
          @click="gotoAssign"
          type="primary"
          block
          >{{ assignStatus.text }}
          <span class="sumbit-time-end">{{
            assignEndTimeText
          }}</span></van-button
        >
        <van-button v-else color="#D8D8D8" block>{{
          assignStatus.text
        }}</van-button>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import { activityDetailAPI } from "@/api/activity";
import { BridgeNativeMethods } from "@/assets/js/jsbridge";
import { checkResponse, TimeFormat } from "@/assets/js/utils";
import dayjs from "dayjs";
import debounce from "lodash.debounce";
export default {
  name: "ActivityDetail",
  data() {
    return {
      isRefresh: false,
      activityId: null,
      activityData: {
        title: "",
        image: "",
        startTime: 0,
        endTime: 0,
        finished: false,
        address: "",
        details: "",
        signUpStartTime: 0,
        signUpEndTime: 0,
        isSignUp: false, // 是否需要报名
      },
      assignStatus: {
        text: "",
        status: false,
      },
    };
  },
  computed: {
    startTimeText() {
      return TimeFormat.timestampSecondToChinese(this.activityData.startTime);
    },
    endTimeText() {
      return TimeFormat.timestampSecondToChinese(this.activityData.endTime);
    },
    assignEndTimeText() {
      return this.activityData.signUpEndTime
        ? `截止${TimeFormat.timestampSecond(
            this.activityData.signUpEndTime,
            "M月DD HH:mm"
          )}`
        : "";
    },
  },
  mounted() {
    this.activityId = this.$route.params.id;
    console.log("activityid:" + this.activityId);
    BridgeNativeMethods.setTitle("活动详情");
    this.requestData();
    this.debouncedClick = debounce(this.gotoAssign, 500);
  },
  unmounted() {
    // 移除组件时，取消定时器
    this.debouncedClick.cancel();
  },
  methods: {
    requestData() {
      BridgeNativeMethods.showLoading();
      activityDetailAPI(this.activityId).then(
        (response) => {
          console.log("activity detail success", response);
          this.isRefresh = false;
          BridgeNativeMethods.hideLoading();
          if (checkResponse(response)) {
            let {
              title,
              image,
              startTime,
              endTime,
              finished,
              address,
              details,
              signUpStartTime,
              signUpEndTime,
              isSignUp,
              isStart,
            } = response.data;
            this.activityData.title = title;
            this.activityData.image = image;
            this.activityData.finished = finished;
            this.activityData.address = address;
            this.activityData.details = details;
            this.activityData.startTime = startTime;
            this.activityData.endTime = endTime;
            this.activityData.signUpStartTime = signUpStartTime;
            this.activityData.signUpEndTime = signUpEndTime;
            this.activityData.isSignUp = isSignUp;
            if (finished) {
              this.assignStatus = { text: "活动已结束", status: false };
            } else if (!isStart) {
              // 活动未发布
              this.assignStatus = { text: "报名参加", status: false };
            } else {
              if (dayjs().isBefore(dayjs.unix(signUpEndTime))) {
                this.assignStatus = { text: "报名参加", status: true };
              } else {
                this.assignStatus = { text: "报名已结束", status: false };
              }
            }
          } else {
            BridgeNativeMethods.showToast(response.message);
          }
        },
        (err) => {
          this.isRefresh = false;
          BridgeNativeMethods.hideLoading();
          BridgeNativeMethods.showToast("请求错误");
          console.log("activity detail err", err);
        }
      );
    },
    onRefresh() {
      this.isRefresh = true;
      this.requestData();
    },
    gotoAssign() {
      this.$router.push({
        name: "ActivityAssign",
        params: { id: this.activityId },
      });
    },
  },
};
</script>
<style scoped lang="less">
.activity-detail {
  background: white;
}
.cover {
  height: 188px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.info {
  background: #ffffff;
  box-shadow: 0px 1px 5px 0px rgba(153, 153, 153, 0.2);
  border-radius: 8px;
  padding: 12px 16px;
  margin: -50px 16px 16px 16px;
  position: relative;
  .title {
    font-size: 16px;
    line-height: 24px;
  }
  .time,
  .address {
    font-size: @font-size-sm;
    color: @gray-6;
  }
  .time {
    margin-top: 8px;
  }
  .address {
    margin-top: 4px;
  }
  .status {
    width: 68px;
    height: 68px;
    position: absolute;
    right: 0;
    top: 0;
    background: url("~@/assets/images/activity_end.png") center center/cover
      no-repeat;
  }
}
.content {
  padding: 16px;
  margin-bottom: 56px;
}
.submit-box {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 8px;
  z-index: 10;
  background: #ffffff;
}
.sumbit-time-end {
  font-size: @font-size-sm;
  margin-left: 8px;
}
</style>